import request from '@/utils/request'

// 查询码上办-栏目管理列表
export function listLmgl(query) {
  return request({
    url: '/web/lmgl/list',
    method: 'get',
    params: query
  })
}

// 查询码上办-栏目管理详细
export function getLmgl(lmglId) {
  return request({
    url: '/web/lmgl/getInfo/' + lmglId,
    method: 'get'
  })
}

// 新增码上办-栏目管理
export function addLmgl(data) {
  return request({
    url: '/web/lmgl/add',
    method: 'post',
    data: data
  })
}

// 修改码上办-栏目管理
export function updateLmgl(data) {
  return request({
    url: '/web/lmgl/edit',
    method: 'post',
    data: data
  })
}

// 删除码上办-栏目管理
export function delLmgl(lmglId) {
  return request({
    url: '/web/lmgl/delete/' + lmglId,
    method: 'post'
  })
}

// 获取本级栏目排序号
export function getOderNumByPreid(preid){
  return request({
    url: '/web/lmgl/getOderNumByPreid/' + preid,
    method: 'get'
  })
}
